import React from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import LoginCard from "../../../molecules/LoginCard";
import AboutInfo from "../../../molecules/AboutInfo";
import AuthLegalLinks from "../../../molecules/AuthLegalLinks";
import MusicalAnimatedBackground from "../../../organisms/Background/MusicalAnimatedBackground/MusicalAnimatedBackground";
import "./index.css";

const LoginPage = () => {
    const { isLoggedIn } = useSelector(state => state.auth);
    const navigate = useNavigate();

    // Redirect if already logged in
    if (isLoggedIn) {
        navigate("/");
        return null;
    }

    return (
        <div className="login-page">
            <MusicalAnimatedBackground />
            <div className="login-container">
                <LoginCard />
            </div>
            <AuthLegalLinks />
            <AboutInfo />
        </div>
    );
};

export { LoginPage };
